// extracted by mini-css-extract-plugin
export default {"container":"NK-z","topReviewHeading":"OK-z","criticalReview":"PK-z","favorableReview":"QK-z","vsSeparator":"RK-z"};